import { render } from "./HelloWorld.vue?vue&type=template&id=8abb4694&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=8abb4694&scoped=true&lang=scss"

import exportComponent from "/home/jamin/Ideas/wedding/website4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abb4694"]])

export default __exports__